import React, { ReactElement } from "react";

import emptyScene from "../../assets/dekor-zonder-kast.webp";

import { Scene, Overlay } from "./components";

export type Props = {
  readonly onClick?: () => Promise<void>;
};

const IntroEmptyScene = ({ onClick }: Props): ReactElement => (
  <Scene
    src={emptyScene}
    alt="Decor zonder kast"
    onClick={onClick}
    onTouchStart={onClick}
  />
);

export { Overlay };

export default IntroEmptyScene;
